
import { IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle } from '@ionic/react'

import './WorkExperience.css'
import WEFacebook from './WorkExperiences/WEFacebook'
import WEAppDev from './WorkExperiences/WEAppDev'
import WEPolsky from './WorkExperiences/WEPolsky'
import WECharacTour from './WorkExperiences/WECharacTour'

function WorkExperience(){
  return (
    <IonCard className="ion-padding">
      <IonCardHeader>
        <IonCardTitle className="ion-text-center">Work Experience</IonCardTitle>
        <IonCardSubtitle className="ion-text-center">
          Click an item to learn more
        </IonCardSubtitle>
      </IonCardHeader>
      <IonCard className = "ion-padding">
        <WEFacebook />
        <WEAppDev />
        <WEPolsky />
        <WECharacTour />
      </IonCard>
    </IonCard>
  );
}

export default WorkExperience